import React from "react";
import { Box } from "@material-ui/core";
import TextResponseComponent from "./TextResponseComponent";
import PickerResponseComponent from "./PickerResponseComponent";
import CompassResponseComponent from "./CompassResponseComponent";
import SwitchResponseComponent from "./SwitchResponseComponent";
import PotentiometerResponseComponent from "./PotentiometerResponseComponent";
import TeamPhotoResponseComponent from "./TeamPhotoResponseComponent";
import MultipleChoiceResponseComponent from "./MultipleChoiceResponseComponent";
import RecomposeWordResponseComponent from "./RecomposeWordResponseComponent";

const ResponseTypeSelector = (props) => {
  const renderResponseComponent = () => {
    switch (props.state.formDatas.responseType) {
      case "text":
        return <TextResponseComponent {...props} />;
      case "picker":
        return <PickerResponseComponent {...props} />;
      case "multipleChoice":
        return <MultipleChoiceResponseComponent {...props} />;
      case "recomposeWord":
        return <RecomposeWordResponseComponent {...props} />;
      case "compass":
        return <CompassResponseComponent {...props} />;
      case "switch":
        return <SwitchResponseComponent {...props} />;
      case "potentiometer":
        return <PotentiometerResponseComponent {...props} />;
      case "teamPhoto":
        return <TeamPhotoResponseComponent {...props} />;
      default:
        return null;
    }
  };

  return (
    <Box className={props.classes.responseBlock}>
      {renderResponseComponent()}
    </Box>
  );
};

export default ResponseTypeSelector;
